var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 272.62 272.62",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#2969B3;}\r\n\t.st2{fill:#222653;}\r\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:8;}\r\n\t.st4{fill:#CDEAE8;}\r\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:8.1379,8.1379;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_23"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.25,155.3c0.61-13.76,0-38.22,0-48s0.61-46.78,7.03-55.34s5.2-7.95,11.92-11.01 c6.73-3.06,17.73-4.59,33.94-15.29c16.2-10.7,19.57-8.87,19.87-20.18C80.07,3.18,80.1,1.41,80.05,0H0v272.62h0.69 c1-15.88,0.93-41.97,2.27-54.35C4.5,204.21,6.64,169.05,7.25,155.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M197.41,114.33c0,0-1.53-2.45-1.53,3.67s-10.7,111.99-10.7,111.99s0.31,6.02,1.53,11.53 c0.04,0.17-0.01,0.35-0.13,0.54c0.38-0.27,0.63-0.47,0.79-0.62c-0.08-0.29-0.12-0.45-0.12-0.45s0.76-0.16,0.12,0.45 c0.53,1.96,2.68,10.09,4.58,18.58c0.68,3.04,1.55,7.5,2.47,12.61h25.94c0.19-13.33,2.57-50.89,5.79-55.88 C223.71,207.58,197.41,114.33,197.41,114.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.46,244.01c-3.95,1.69-11.3,3.68-20.84,5.46C173.27,247.5,181.12,245.39,183.46,244.01 C183.46,244.02,183.46,244.02,183.46,244.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.7,250.35c-15.18,2.52-34.77,4.39-54.89,3.97c0.02,0,0.04,0,0.07,0 C120.91,255.18,141.67,253.03,157.7,250.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.83,118.3c-1.76,13.45-7.26,81.02-9.4,96.61c-1.57,11.46-3.81,37.92-6.46,57.71h10.44 c0.82-4.79,1.6-9.61,5.42-26.95C47.83,245.68,48.06,128.7,47.83,118.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.98,0c2.23,2.14,4.62,3.75,7.07,4.57c9.17,3.06,29.96,2.75,47.39,6.11c17.43,3.36,24.76,5.2,29.35,23.54 c4.59,18.34,23.24,81.02,25.68,91.72c2.45,10.7,18.96,70.32,18.96,70.32s6.11,17.12,0,43.72c-2.01,8.73-4.9,20.61-7.88,32.64 h13.08V0H138.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.95,250.31c0.51-0.08,1.01-0.17,1.5-0.26C158.96,250.13,158.46,250.22,157.95,250.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.78,249.81c0.35-0.06,0.71-0.13,1.06-0.19C161.49,249.69,161.13,249.75,160.78,249.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.37,241.43c-0.16,0.15-0.41,0.35-0.79,0.62c-0.37,0.57-1.44,1.24-3.12,1.96c0,0,0,0-0.01,0 c-2.34,1.37-10.19,3.49-20.83,5.46c-0.26,0.05-0.52,0.1-0.79,0.15c-0.35,0.06-0.7,0.13-1.06,0.19c-0.44,0.08-0.88,0.16-1.33,0.23 c-0.5,0.09-1,0.17-1.5,0.26c-0.08,0.01-0.17,0.03-0.25,0.04c-16.03,2.69-36.79,4.83-54.82,3.98c-0.02,0-0.04,0-0.07,0 c-18.93-0.39-38.33-2.81-54.97-8.64c-3.82,17.33-4.6,22.15-5.42,26.95h152.01c-0.92-5.11-1.79-9.58-2.47-12.61 C190.05,251.53,187.9,243.4,187.37,241.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.25,240.98c0,0,0.04,0.16,0.12,0.45C188.01,240.82,187.25,240.98,187.25,240.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M267.43,196.26c0,0-16.51-59.62-18.96-70.32c-2.45-10.7-21.1-73.38-25.68-91.72 c-4.59-18.34-11.92-20.18-29.35-23.54c-17.43-3.36-38.22-3.06-47.39-6.11c-2.46-0.82-4.84-2.43-7.07-4.57H80.05 c0.05,1.41,0.03,3.18-0.04,5.49c-0.31,11.31-3.67,9.48-19.87,20.18c-16.2,10.7-27.21,12.23-33.94,15.29 c-6.73,3.06-5.5,2.45-11.92,11.01S7.25,97.51,7.25,107.3s0.61,34.24,0,48s-2.75,48.92-4.28,62.98 c-1.34,12.37-1.27,38.47-2.27,54.35h31.28c2.65-19.79,4.88-46.25,6.46-57.71c2.14-15.59,7.64-83.16,9.4-96.61 c0.23,10.4,0,127.38,0,127.38c16.65,5.83,36.05,8.25,54.97,8.64c20.12,0.42,39.71-1.45,54.89-3.97c0.08-0.01,0.17-0.03,0.25-0.04 c0.51-0.08,1.01-0.17,1.5-0.26c0.45-0.08,0.89-0.16,1.33-0.23c0.35-0.06,0.71-0.13,1.06-0.19c0.27-0.05,0.53-0.1,0.79-0.15 c9.54-1.78,16.88-3.77,20.84-5.46c1.68-0.72,2.75-1.39,3.12-1.96c0.12-0.19,0.17-0.37,0.13-0.54c-1.22-5.5-1.53-11.53-1.53-11.53 s10.7-105.88,10.7-111.99s1.53-3.67,1.53-3.67s26.29,93.25,28.74,102.42c-3.22,4.98-5.6,42.54-5.79,55.88h39.19 c2.98-12.03,5.88-23.91,7.88-32.64C273.54,213.39,267.43,196.26,267.43,196.26z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M206.42,146.3c0,0,23.71,12.6,44.8-9.53"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_22"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_21"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_20"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_16"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_19"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_18"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_33"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_32"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_31"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_30"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_29"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_28"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_27"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_26"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_25"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_24"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Base"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage6);
export default __webpack_public_path__ + "static/media/image6.1f5042d033be27b51b720e8a386165f2.svg";
export { ForwardRef as ReactComponent };